import axiosClient from "./axiosClient";

// Matches AboutUsMediaType on the API (enums are serialized as numbers).
export const AboutUsMediaType = {
  Image: 1,
  Video: 2,
};

// Hidden (inactive) posts are only returned to admins who ask for them.
export async function getAboutUsPosts(includeInactive = false) {
  const response = await axiosClient.get("/aboutus/posts", { params: includeInactive ? { includeInactive: true } : undefined });
  return response.data;
}

export async function setAboutUsPostActive(id, isActive) {
  const response = await axiosClient.put(`/aboutus/posts/${id}/active`, { isActive });
  return response.data;
}

// Uploads every file of one post in a single request. Videos can be large, so the
// default 30s client timeout is lifted and progress (0..1) is reported instead.
export async function createAboutUsPost(files, caption, onProgress) {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  if (caption) formData.append("caption", caption);
  const response = await axiosClient.post("/aboutus/posts", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 0,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(e.loaded / e.total);
    },
  });
  return response.data;
}

export async function updateAboutUsPost(id, caption) {
  const response = await axiosClient.put(`/aboutus/posts/${id}`, { caption });
  return response.data;
}

export async function reorderAboutUsPosts(postIds) {
  await axiosClient.put("/aboutus/posts/order", { postIds });
}

export async function deleteAboutUsPost(id) {
  await axiosClient.delete(`/aboutus/posts/${id}`);
}

// "How to use the app" videos shown above the gallery: one video + title + description each.
export async function getAboutUsTutorials(includeInactive = false) {
  const response = await axiosClient.get("/aboutus/tutorials", { params: includeInactive ? { includeInactive: true } : undefined });
  return response.data;
}

export async function setAboutUsTutorialActive(id, isActive) {
  const response = await axiosClient.put(`/aboutus/tutorials/${id}/active`, { isActive });
  return response.data;
}

export async function createAboutUsTutorial(file, title, description, onProgress) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("title", title);
  if (description) formData.append("description", description);
  const response = await axiosClient.post("/aboutus/tutorials", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 0,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(e.loaded / e.total);
    },
  });
  return response.data;
}

export async function updateAboutUsTutorial(id, title, description) {
  const response = await axiosClient.put(`/aboutus/tutorials/${id}`, { title, description });
  return response.data;
}

export async function reorderAboutUsTutorials(tutorialIds) {
  await axiosClient.put("/aboutus/tutorials/order", { tutorialIds });
}

export async function deleteAboutUsTutorial(id) {
  await axiosClient.delete(`/aboutus/tutorials/${id}`);
}
